module.exports = __webpack_public_path__ + "img/45_29.2ed28fd8.png";